import { ExportProgressState } from '../types';

const resolveProgressPercent = (
  progress: ExportProgressState | null | undefined
): number => {
  if (!progress || progress.total <= 0) {
    return 0;
  }

  // Clamp into [0, 99] so the determinate label only flips to 100% on completion.
  return Math.min(99, Math.floor((progress.processed / progress.total) * 100));
};

export default resolveProgressPercent;
